import React from "react";
import Layout from "../../components/Layout/Layout";
import MelorianBijoux from "../../components/Projets/MelorianBijoux";
import { Splide, SplideSlide } from "@splidejs/react-splide";

class ProjetsMelorianBijoux extends React.Component {
  componentDidMount() {
    document.title = "Melorian Bijoux";
  }

  render() {
    return (
      <div>
        <Layout>
          <section class="container-white competence margin_80">
            <div class="competence-body">
              <div class="row">
                <h1 class="margin_60_0">EXPERIENCE PROFESSIONNELLES</h1>
                <MelorianBijoux />
              </div>
            </div>
            <div>
              <Splide
                options={{
                  type: "loop",
                  autoWidth: true,
                }}
                aria-label="My Favorite Images"
              >
                <SplideSlide>
                  <img
                    class="projets-img"
                    src="/images/melorianbijoux/melorianbijoux-img.png"
                    alt="MelorianBijoux"
                  />
                </SplideSlide>
              </Splide>
            </div>
          </section>
        </Layout>
      </div>
    );
  }
}

export default ProjetsMelorianBijoux;
